<template>
  <div>
    <div
      v-if="loading"
      id="carregaDados"
      class="text-center"
      :style="styleObject"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando Dados...
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <div>
      <canvas
        id="fatMetaMedia"
      />
      <div
        id="legendabarline"
        class="text-center px-2"
      >
        <v-row
          align="center"
          class="ma-0"
        >
          <v-avatar
            class="mr-1"
            color="#ed934f"
            size="12"
          />
          <span class="mr-3 font-weight-light">Meta Diária</span>
          <v-avatar
            class="mr-1"
            color="#4780b8"
            size="12"
          />
          <span class="mr-3 font-weight-light">Acima da Meta</span>
          <v-avatar
            class="mr-1"
            color="#cadaed"
            size="12"
          />
          <span class="mr-3 font-weight-light">Abaixo da Meta</span>
          <v-avatar
            class="mr-1"
            color="#BF360C"
            size="12"
          />
          <span class="mr-3 font-weight-light">Média Diaria</span>
        </v-row>
      </div>
    </div>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import Comercial from '../../../../services/comercial4'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'DashboardChartLineBar',
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
    },

    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      colors: [],
      myChart: {},
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      supervisor: [],
      receita: [],
      text: null,
      montarGrafico: true,
      loading: false,
      error: null,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
    }),

    created () {
      eventEmit.$on('update-datas', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-datas', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, supervisor, receita) {
        this.primeiroDia = primeiroDia
        this.dataFinal = dataFinal
        this.select = select
        this.supervisor = supervisor
        this.receita = receita

        this.atualizaGrafico()
      },

      async atualizaGrafico () {
        this.loading = true

        if (this.myChart.data) {
          this.myChart.destroy()
        }

        await Comercial.showDadosGraficoBarrasFaturamentoxMetaxMedia(this.primeiroDia, this.dataFinal, this.select, this.supervisor, this.receita, localStorage.tokencontrato).then(resposta => {
          this.error = null

          if (resposta.data.status) {
            const ctx = document.getElementById('fatMetaMedia').getContext('2d')

            this.myChart = new Chart(ctx, {
              type: 'bar',
              data: {
                labels: resposta.data.diasFaturamento,
                datasets: [
                  {
                    label: 'Faturamento',
                    data: resposta.data.faturamentoMensal,
                    backgroundColor: resposta.data.colors,
                    order: 3,
                  },
                  {
                    label: 'Meta',
                    data: resposta.data.valorMeta,
                    type: 'line',
                    borderColor: '#ed934f',
                    backgroundColor: 'transparent',
                    order: 1,
                  },
                  {
                    label: 'Média Diária',
                    data: resposta.data.mediaDiaria,
                    type: 'line',
                    borderColor: '#BF360C',
                    backgroundColor: 'transparent',
                    order: 2,
                    tension: 0.1,
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                  }],
                  yAxes: [{
                    ticks: {
                      min: 0,
                    },
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                low: 10,
                high: 5,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        return 'Faturamento - ' + tooltipItem[0].xLabel
                      } else if (tooltipItem[0].datasetIndex === 1) {
                        return 'Meta - ' + tooltipItem[0].xLabel
                      } else if (tooltipItem[0].datasetIndex === 2) {
                        return 'Média Diária - ' + tooltipItem[0].xLabel
                      }
                    },
                  },
                },
              },
            })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.text = resposta.data.text

            this.error = this.text

            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.text)
          } else if (resposta.data.text === 'Não há meta no período selecionado') {
            this.text = resposta.data.text

            this.error = this.text

            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {
    #fatMetaMedia {
      font-size: 14px;
      display: grid;
      align-items: center;
      font-weight: bold;
      margin: 5rem 0 0 0;
    }

    #legendabarline {
      font-size: 9px;
      display: flex;
      flex-wrap: wrap;
      margin: 0.5rem 0 0 1rem;
    }
  }

  @media screen
  and (min-width : 600px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #fatMetaMedia {
      font-size: 20px;
      display: grid;
      align-items: center;
      font-weight: bold;
    }

    #legendabarline {
      font-size: 9px;
      display: flex;
      flex-wrap: wrap;
      margin: 0.5rem 0 0 15rem;
    }
  }
</style>

<style lang="sass">
  #fatMetaMedia
    font-size: 20px
    display: grid
    align-items: center
    font-weight: bold
    width: 750
    height: 330

  #legendabarline
    font-size: 10px
    display: grid
    align-items: center
    margin: 0 75px

</style>
